// @ts-nocheck
import { useCallback, useEffect, useRef } from 'react';

function useIfMounted() {
  const ref = useRef(true);
  useEffect(
    () => () => {
      ref.current = false;
    },
    []
  );
  return useCallback(callback => {
    if (ref.current) {
      callback?.();
    }
  }, []);
}

export default useIfMounted;
